'use strict';

var _err = window.onerror;
var url = location.protocol + '//catdot.dianping.com/broker-service/api/js';
window.onerror = function(err, file, line, col, error){
  var e = encodeURIComponent;
  var time = Date.now();
  (new window.Image).src = url
    + '?error=' + e(err)
    + '&v=1'
    + '&data=' + e(error && error.stack ? error.stack : '')
    + '&url=' + e(location.href)
    + '&file=' + e(file)
    + '&line=' + e(line)
    + '&col=' + e(col)
    + '&timestamp=' + time;
  _err && _err(err, file, line, col, error);
};


// WEBPACK FOOTER //
// ./~/@dp/dpapp/lib/errortrace.js